import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import { useEffect, useState } from 'react';
import SnackbarAlert from '../common/SnackbarAlert';
import DocumentNameList from './DocumentList';
import { checkPermission } from '../../utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import DocumentNameCreateEdit from './CreateEdit';
import Loader from '../common/Loader';

function DocumentNames() {
  const [showCreateEdit, setShowCreateEdit] = useState(false);
  const [stateEditDatas, setStateEditDatas] = useState();
  const [editStatus, setEditStatus] = useState(false);
  const [documentNameViewPermission, setDocumentNameViewPermission] =
    useState(false);
  const [isLoading, setLoading] = useState(true);

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const showCreateEditForm = () => {
    setShowCreateEdit(true);
  };

  const closeCreateEditForm = (status) => {
    setEditStatus(false);
    setStateEditDatas(null);
    setShowCreateEdit(false);

    if (status === true) {
      setShowSnackBarAlert({
        status: true,
        type: 'success',
        message: editStatus
          ? 'Document Name updated'
          : 'Document Name saved'
      });
    }
  };

  const editDatas = (editData) => {
    setEditStatus(true);
    setStateEditDatas(editData);
    setShowCreateEdit(true);
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({
      status: false,
      type: null,
      message: null
    });
  };

  useEffect(() => {
    checkRolePermission();
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('documentName', 'View').then((permission) => {
      setDocumentNameViewPermission(permission);
      setLoading(false);
    });
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      {showCreateEdit ? (
        <DocumentNameCreateEdit
          closeCreateEditForm={closeCreateEditForm}
          stateEditDatas={stateEditDatas}
          editStatus={editStatus}
        />
      ) : (
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
            style={{ minHeight: '81vh' }}
          >
            <Grid item xs={12} className="ListContainer">
              {documentNameViewPermission ? (
                <DocumentNameList
                  editDatas={editDatas}
                  showCreateEditForm={showCreateEditForm}
                />
              ) : isLoading ? (
                <Loader />
              ) : (
                <NoPermissionContent />
              )}
            </Grid>
          </Grid>
        </Container>
      )}

      <Footer />
    </>
  );
}

export default DocumentNames;